module.exports = __webpack_public_path__ + "media/src/img/payment/oi-93e1786351cc65ab1bae8bc9c503ae53.svg";